// extracted by mini-css-extract-plugin
export default {"root":"zAZFo2BkhBeFIA2s9nta","paragraphs":"e26W9jhcmX3YobLJjgE1","actions":"CkTFBFl5_AHHZbrnDJjj"};